import { useState, useEffect, useContext } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Link, useHistory } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { userService } from "../../services/UserService";
import AuthContext from "../../store/auth-context";
import { Snackbar, TextField } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import InfiniteScroll from "react-infinite-scroll-component";
import { useTranslation } from "react-i18next";
import SearchUser from "./SearchUser";
import countryList from "../../constants/countryList.json";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Paper from "@material-ui/core/Paper";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";

function ManageUser() {
  const authCtx = useContext(AuthContext);
  const [t] = useTranslation();
  const [showAddModal, setShowAddModal] = useState<boolean>(false);
  const [showModal, setShowModal] = useState<boolean>(false);
  const [modalText, setModalText] = useState<string>("");
  const [modalType, setModalType] = useState<string>("error");
  const [skip, setSkip] = useState<number>(0);
  const [take, setTake] = useState<number>(50);
  const [allAdminList, setallAdminList] = useState<any>([]);
  const [userRoleList, setUserRoleList] = useState<any>([]);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [callingCode, setCallingCode] = useState("971");
  const [mobile, setLoginMobile] = useState<string>("");
  const [mobileError, setLoginMobileError] = useState<boolean>(false);
  const [userDetails, setUserDetails] = useState<any>({});
  const [isEditted, setIsEditted] = useState<boolean>(false);
  const [isReload, setIsReload] = useState<boolean>(false);

  useEffect(() => {
    fetchUserRoleList();
  }, []);

  useEffect(() => {
    fetchAllAdminList();
  }, [isReload]);

  const setpage = async () => {
    authCtx.toggleLoader(true);
    const nextAdminList = await userService.getAllAdmins(skip, take);
    if (nextAdminList && nextAdminList.data && nextAdminList.data.data) {
      setallAdminList([...allAdminList, ...nextAdminList.data.data]);

      if (nextAdminList.data.data.length === 0) {
        setHasMore(false);
      } else {
        setHasMore(true);
        setSkip(skip + take);
      }
    } else {
      setallAdminList([]);
    }
    authCtx.toggleLoader(false);
  };

  const fetchUserRoleList = async () => {
    const res = await userService.getUserRoleList();
    if (res && res.length > 0) {
      setUserRoleList(res);
    } else {
      setUserRoleList([]);
    }
  };

  const fetchAllAdminList = async () => {
    authCtx.toggleLoader(true);
    const res = await userService.getAllAdmins(skip, take);
    if (res && res.message && res.message.status === "Success") {
      setallAdminList(res.data.data);
      setSkip(skip + take);
    } else {
      setShowModal(true);
      setModalType("error");
      setModalText(t("Error"));
    }
    authCtx.toggleLoader(false);
  };

  const handleMobileChange = (e: any) => {
    setLoginMobile(e.target.value);
    setLoginMobileError(false);
  };

  function validateForm() {
    let isValid = true;
    if (callingCode === "" || mobile === "" || mobile.length < 8) {
      setLoginMobileError(true);
      setShowModal(true);
      setModalType("error");
      setModalText(t("Please enter valid Mobile Number"));
      isValid = false;
    }
    return isValid;
  }

  const handleUserSearch = async () => {
    authCtx.toggleLoader(true);
    if (validateForm()) {
      const res = await userService.searchUser(callingCode, mobile);
      if (
        res &&
        res.message &&
        res.message.status &&
        res.message.status === "Success"
      ) {
        setUserDetails(res.data);
        setIsEditted(false);
        setShowAddModal(true);
      } else if (
        res &&
        res.message &&
        res.message.status &&
        res.message.status === "Conflict"
      ) {
        setShowModal(true);
        setModalType("error");
        setModalText(res.message.message);
      } else if (
        res &&
        res.message &&
        res.message.status &&
        res.message.status === "NotFound"
      ) {
        setShowModal(true);
        setModalType("error");
        setModalText(t("User not found, please register"));
      } else {
        setShowModal(true);
        setModalType("error");
        setModalText(t("Something went wrong!"));
      }
    }
    authCtx.toggleLoader(false);
  };

  const handleAddClose = async () => {
    setShowAddModal(false);
    setIsEditted(false);
  };

  const handleEditShow = (data: any) => {
    setUserDetails(data);
    setIsEditted(true);
    setShowAddModal(true);
  };

  const handleClose = () => setShowModal(false);

  const openMobileMenu = (e: any) => {
    e.preventDefault();

    document.getElementById("leftMenu")?.classList.remove("d-none");
  };

  return (
    <>
      <div className="main-content animate py-4 px-3 px-sm-4">
        <div className="d-sm-flex align-items-center mb-3">
          <a
            href="#"
            className="d-inline-block d-sm-none text-dark"
            onClick={(e) => openMobileMenu(e)}
          >
            <i className="material-icons-outlined me-2">menu</i>
          </a>

          <h3 className="fs-18-24">{t("User Management")}</h3>
        </div>

        <div className="d-inline-flex flex-wrap w-100">
          <div className="user-managemnet user-managemnet-textfiled  ms-auto">
            <div className="card border-0 shadow-sm rounded-10">
              <div className="input-group">
                {countryList && callingCode && (
                  <Autocomplete
                    id="country-select-demo"
                    options={countryList}
                    disableClearable
                    autoHighlight
                    size="small"
                    defaultValue={countryList.find(
                      (x) => x.phoneCode === callingCode
                    )}
                    onChange={(event, value) => {
                      setCallingCode(value.phoneCode);
                    }}
                    filterOptions={createFilterOptions({
                      stringify: (option) =>
                        "+" + option.phoneCode + option.name,
                    })}
                    getOptionLabel={(option) =>
                      authCtx.selectedLanguage === "en"
                        ? "+" + option.phoneCode
                        : option.phoneCode + "+"
                    }
                    PaperComponent={({ children }) => (
                      <Paper style={{ minWidth: "400px" }}>{children}</Paper>
                    )}
                    style={{ minWidth: "100px" }}
                    renderOption={(option) => (
                      <>
                        {option.name} (+{option.phoneCode})
                      </>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        inputProps={{
                          ...params.inputProps,
                          autoComplete: "new-password", // disable autocomplete and autofill
                        }}
                      />
                    )}
                  />
                )}

                <TextField
                  required
                  autoComplete="off"
                  id="mobile"
                  label={t("Mobile No.*")}
                  name="mobile"
                  className="form-control"
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 10, minLength: 8 }}
                  error={mobileError}
                  value={mobile}
                  onKeyPress={(event) => {
                    if (!/[0-9]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  onChange={(e: any) => {
                    handleMobileChange(e);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 ms-2 my-lg-0 my-2">
            <button
              className="btn btn-primary no-focus w-100"
              onClick={handleUserSearch}
            >
              {t("Search Any User")}
            </button>
          </div>
        </div>
        <div className="card border-0 shadow-sm rounded-3 mt-3">
          {allAdminList && allAdminList.length > 0 && (
            <div className="card-body px-4">
              <h6 className="text-primary"> {t("Administrators")}</h6>
            </div>
          )}
          {allAdminList && allAdminList.length > 0 && (
            <div className="card-body p-4">
              {/* <h6 className="text-primary mb-4 ms-1">
                {" "}
                {t("List Of Administrators")}
              </h6> */}
              <InfiniteScroll
                dataLength={allAdminList.length}
                next={setpage}
                hasMore={hasMore}
                loader={false}
              >
                <div className="table-responsive-lg">
                  <table className="table align-middle">
                    <thead>
                      <tr>
                        <th scope="col">{t("Name")}</th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Mobile No.*")}
                        </th>
                        <th scope="col" className="d-none d-sm-table-cell">
                          {t("Email ID*")}
                        </th>
                        <th scope="col">{t("Role")}</th>
                        <th scope="col">{t("Action")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {allAdminList &&
                        allAdminList.length > 0 &&
                        allAdminList.map((item: any) => (
                          <tr key={item.id}>
                            <td>
                              {item.firstName} {item.lastName}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.callingCode}-{item.mobile}
                            </td>
                            <td className="d-none d-sm-table-cell">
                              {item.email}
                            </td>
                            <td>{item.roleName}</td>
                            <td>
                              <Link
                                to="#"
                                className="me-2"
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleEditShow(item);
                                }}
                              >
                                <i className="material-icons-outlined">edit</i>
                              </Link>
                            </td>
                            {/* <td className="w-150">
                            <Link to="#" className="btn btn-link p-0 no-focus"
                                onClick={(e)=>{e.preventDefault();setResetPassUserData(item);setResetPassAskModel(true);}}
                                >
                              Reset password
                            </Link>
                          </td> */}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </InfiniteScroll>
            </div>
          )}
          {allAdminList && allAdminList.length === 0 && (
            <div className="card-body p-4">
              <div className="text-center text-999">
                {" "}
                <i className="material-icons-outlined fs-1"> info </i>
                <p className="fs-6">{t("No record found")}</p>
              </div>
            </div>
          )}
        </div>
      </div>

      <Dialog
        open={showAddModal}
        fullWidth={true}
        maxWidth="sm"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("User Details")}
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={handleAddClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="pt-0">
          <DialogContentText id="alert-dialog-description">
            <SearchUser
              isEditted={isEditted}
              handleAddClose={handleAddClose}
              userDetails={userDetails}
              userRoleList={userRoleList}
              setIsReload={setIsReload}
              isReload={isReload}
              setSkip={setSkip}
              setShowModal={setShowModal}
              setModalType={setModalType}
              setModalText={setModalText}
            />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      {modalType === "error" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="error">
            {modalText}
          </Alert>
        </Snackbar>
      )}
      {modalType === "success" && (
        <Snackbar
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          open={showModal}
          autoHideDuration={3000}
          onClose={handleClose}
        >
          <Alert onClose={handleClose} severity="success">
            {modalText}
          </Alert>
        </Snackbar>
      )}
    </>
  );
}

export default ManageUser;
